import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import {UserProvider} from "../../providers/user";
import {TeamappProvider} from "../../providers/teamapp";

import {JobsDetailsPage} from '../jobs-details/jobs-details';
/**
 * Generated class for the JobsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-jobs',
  templateUrl: 'jobs.html',
})
export class JobsPage {
  title: string = 'Jobs';
  jobs: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider) {
    if(this.navParams.get("title")) {
      this.title = this.navParams.get("title");
    }
    this.teamappProvider.http_request('action=get_jobs', 'jobs', false, true).then(data => {
      this.jobs = data;
      console.log(this.jobs);
    });
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad JobsPage');
  }

  openJob(job: any) {
    this.navCtrl.push(JobsDetailsPage,{details: job});
  }

}



// WEBPACK FOOTER //
// ./src/pages/jobs/jobs.ts